import { DestinationPage, Page } from '@components/ssap/SsapTypes';

interface CurrentAndMaxAchievedPages {
    currentPage: Page,
    maxAchievedPage: Page
}

export const getCurrentAndMaxAchievedPages = (
    destinationPage: DestinationPage,
    page: Page,
    maxAchievedPage: Page,
    isDataPotentiallyInconsistent: boolean
): CurrentAndMaxAchievedPages => {
    let currentPage: Page;

    switch(destinationPage) {
        case 'increase':
            currentPage = page + 1; break;
        case 'decrease':
            currentPage = page - 1; break;
        default:
            currentPage = destinationPage; break;
    }

    return {
        currentPage,
        maxAchievedPage: (maxAchievedPage < currentPage || isDataPotentiallyInconsistent)
            ? currentPage
            : maxAchievedPage
    };
};